import { Button, Form, Input, InputNumber, Popconfirm, Radio, Select, Space, Tag } from "antd";
import { colorAreas, colorCurrency } from "../schemesColors";
import { trimSpaces } from "../../helpers/textTransform";
import { jsonDataStatusSimulation } from "../initStore/initSimulation";
import { DeleteFilled, EditFilled, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import { teamAreasByFormHoursAdd } from "../initStore/initUser";

const inputs = {
    name: {
        component: <Input size="large" style={{ width: "100%" }} />,
        rules: [
            {
                required: true,
                message: "Nombre",
            },
        ],
        name: "name",
    },
    price: {
        component: <InputNumber size="large" min={0} style={{ width: "100%" }} />,
        rules: [],
        name: ["price"],
    },
    currency: {
        component: (
            <Radio.Group>
                <Radio.Button value="MXN">MXN</Radio.Button>
                <Radio.Button value="USD">USD</Radio.Button>
            </Radio.Group>
        ),
        rules: [],
        name: ["currency"],
    },
    link: {
        component: <Input size="large" style={{ width: "100%" }} />,
        rules: [],
        name: ["link"],
    },
    status: {
        component: (
            <Select
                showSearch
                placeholder="selecciona un estatus"
                style={{
                    width: "100%",
                }}
            >
                {Object.values(jsonDataStatusSimulation)
                    .map((item) => item.name)
                    .map((statu) => (
                        <Select.Option key={`${statu}-status-table`} value={statu}>
                            {statu}
                        </Select.Option>
                    ))}
            </Select>
        ),
        rules: [
            {
                required: true,
                message: "selecciona un estado",
            },
        ],
        name: ["status"],
    },
    area: {
        component: (
            <Select
                showSearch
                placeholder="selecciona un area"
                style={{
                    width: "100%",
                }}
            >
                {teamAreasByFormHoursAdd().map((area) => (
                    <Select.Option key={`${area}-areas`} value={area}>
                        {area}
                    </Select.Option>
                ))}
            </Select>
        ),
        rules: [
            {
                required: true,
                message: "selecciona una area",
            },
        ],
        name: ["area"],
    },
};

const EditableCell = ({ editing, inputIteam, dataIndex, title, inputType, record, index, children, ...restProps }) => {
    if (editing) {
        return (
            <td {...restProps}>
                <Form.Item
                    name={inputIteam.name}
                    style={{
                        margin: 0,
                    }}
                    rules={inputIteam.rules}
                >
                    {inputIteam.component}
                </Form.Item>
            </td>
        );
    }
    return <td {...restProps}>{children}</td>;
};

const propsColumns = () => {
    return {
        components: {
            body: {
                cell: EditableCell,
            },
        },
        rowClassName: "editable-row",
        scroll: { x: "100%", y: null },
    };
};

const columnsType = (
    action = {
        editAction: () => { },
        deleteAction: () => { },
        isEditing: () => { },
        cancelSave: () => { },
        editSave: () => { },
    },
    values = {
        editingKey: false,
    }
) => {
    return [
        {
            title: "Asset",
            dataIndex: "name",
            key: "name",
            render: (text) => <span className="block w-32">{text}</span>,
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
            editable: true,
        },
        {
            title: "Área",
            dataIndex: "area",
            key: "area",
            render: (text) => {
                let color = "#ccc";
                const colorSchema = colorAreas.find((col) => trimSpaces(col.name) === trimSpaces(text));
                if (colorSchema) {
                    color = colorSchema.color;
                }
                return (
                    <div className="flex items-center gap-2 w-40">
                        <div className="w-fit">
                            <div className="w-4 h-4 rounded-full" style={{ backgroundColor: color }}></div>
                        </div>
                        <span className="font-semibold text-xs">{text}</span>
                    </div>
                );
            },
            sorter: (a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            },
            editable: true,
        },
        {
            title: "Costo",
            dataIndex: "price",
            key: "price",
            render: (text) => <span className="block w-24">{text}</span>,
            editable: true,
        },
        {
            title: "Moneda",
            dataIndex: "currency",
            key: "currency",
            render: (text) => {
                let color = "#ccc";
                const find = colorCurrency.find((col) => col.name === text);
                if (find) {
                    color = find.color;
                }
                return (
                    <div className="w-32">
                        <Tag style={{ color: "black", border: "1px solid", borderColor: color, backgroundColor: `${color}33` }}>{text}</Tag>
                    </div>
                );
            },
            editable: true,
        },
        {
            title: "Equivalencia de HRS",
            dataIndex: "equivalencyHrs",
            key: "equivalencyHrs",
            render: (_, record) => {
                let color = "#ccc";
                if (jsonDataStatusSimulation.Simulation.name === record.status) {
                    color = jsonDataStatusSimulation.Simulation.color;
                }
                return (
                    <Tag style={{ color: "black", border: "1px solid", borderColor: color, backgroundColor: `${color}33` }}>
                        {record.equivalencyHrs}
                    </Tag>
                );
            },
        },
        {
            title: "Enlace",
            dataIndex: "link",
            key: "link",
            render: (text) => <span className="block w-24">{text}</span>,
            editable: true,
        },
        {
            title: "Estatus",
            dataIndex: "status",
            key: "status",
            render: (text) => {
                let color = Object.values(jsonDataStatusSimulation).find((status) => status.name === text)?.color || "#ccc";
                return (
                    <div className="w-24">
                        <Tag color={color} className="py-[2px] px-3">
                            {text}
                        </Tag>
                    </div>
                );
            },
            editable: true,
        },
        {
            title: "Acción",
            key: "action",
            render: (_, record) => {
                const editable = action.isEditing(record);
                if (editable) {
                    return (
                        <Space size="middle">
                            <Button
                                type="text"
                                icon={<SaveOutlined />}
                                onClick={() => {
                                    action.editSave(record.key);
                                }}
                            />
                            <Popconfirm title="Cancelar edición" onConfirm={action.cancelSave}>
                                <Button type="text" icon={<CloseOutlined />} />
                            </Popconfirm>
                        </Space>
                    );
                }
                return (
                    <Space size="middle">
                        <Button
                            type="text"
                            disabled={values.editingKey !== ""}
                            icon={<EditFilled />}
                            onClick={() => {
                                action.editAction(record);
                            }}
                        />
                        <Popconfirm
                            title={`Eliminar`}
                            onConfirm={() => {
                                action.deleteAction(record);
                            }}
                        >
                            <Button disabled={values.editingKey !== ""} type="text" icon={<DeleteFilled />} />
                        </Popconfirm>
                    </Space>
                );
            },
        },
    ];
};

const mergedColumns = (
    action = {
        editAction: () => { },
        deleteAction: () => { },
        isEditing: () => { },
        cancelSave: () => { },
        editSave: () => { },
    },
    values = {
        editingKey: false,
    }
) => {
    const column = columnsType(
        {
            editAction: action.editAction,
            deleteAction: action.deleteAction,
            isEditing: action.isEditing,
            cancelSave: action.cancelSave,
            editSave: action.editSave,
        },
        {
            editingKey: values.editingKey,
        }
    );
    const merge = column.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => {
                return {
                    record,
                    inputIteam: inputs[col.dataIndex],
                    editing: action.isEditing(record),
                };
            },
        };
    });
    return merge;
};

export const columnsAssestSimulation = (editAction, deleteAction, isEditing, editingKey, cancelSave, editSave) => {
    const columns = mergedColumns(
        {
            editAction,
            deleteAction,
            isEditing,
            cancelSave,
            editSave,
        },
        {
            editingKey,
        }
    );
    const props = propsColumns();
    return {
        columns,
        props,
    };
};
